class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.deferLoad = this.hasAttribute('data-defer-load');
    this.onDrawerEvent = this.onDrawerEvent.bind(this);
  }

  connectedCallback() {
    document.addEventListener('cartdrawer:opened', this.onDrawerEvent);
    document.addEventListener('cartdrawer:content-updated', this.onDrawerEvent);

    if (this.deferLoad) {
      return;
    }

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  disconnectedCallback() {
    document.removeEventListener('cartdrawer:opened', this.onDrawerEvent);
    document.removeEventListener('cartdrawer:content-updated', this.onDrawerEvent);
  }

  onDrawerEvent() {
    if (!document.querySelector('cart-drawer details[open]')) return;

    if (this.dataset.url && !this.querySelector('.mini-cart__navigation li')) {
      this.loadRecommendations();
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadRecommendations();
  }

  loadRecommendations() {
    if (!this.dataset.url) return;

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
